<div class="menuitem" (click)="openWhatsNew()">
  <i class="icon-kado"></i>
  <div class="unread-notificatie"[ngClass]="{'hidden': hideAlert}"></div>
</div>
